/* eslint-disable indent */

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import CustomFormDocuments from './components/CustomFormDocumentsQuestions'
import CustomFormSingleUpload from './components/CustomFormSingleUploadQuestion'
import CustomFormCEP from './components/CustomFormCEPQuestion'
import CustomFormNPS from './components/CustomFormNPSQuestion'
import CustomFormEntity from './components/CustomFormEntitiesQuestions'
import CustomFormTextQuestion from './components/CustomFormTextQuestion'
import CustomFormLongTextQuestion from './components/CustomFormLongTextQuestion'
import CustomFormNumberQuestion from './components/CustomFormNumberQuestion'
import CustomFormSingleSelectionBoxQuestion from './components/CustomFormSingleSelectionBoxQuestion'
import CustomFormMultipleSelectionBoxQuestion from './components/CustomFormMultipleSelectionBoxQuestion'
import CustomFormSingleSelectionListQuestion from './components/CustomFormSingleSelectionListQuestion'
import CustomFormMailQuestion from './components/CustomFormMailQuestion'
import CustomFormPhoneQuestion from './components/CustomFormPhoneQuestion'
import CustomFormHourQuestion from './components/CustomFormHourQuestion'
import CustomFormDateQuestion from './components/CustomFormDateQuestion'
import CustomFormMultipleUpload from './components/CustomFormMultipleUploadQuestion'
import { useCustomFormViewer } from '../../../../contexts/CustomFormViewerManager/Provider'

type FormComponentProps = {
  disabled?: boolean
  question: CustomFormQuestion
}

export default function CustomFormViewerQuestionSelection({ question, disabled = true }: FormComponentProps) {
  const { formMethods } = useCustomFormViewer()

  const questionKey = `form_answers.${String(question.slug)}`

  const viewerQuestionProps = {
    question,
    disabled: disabled || question.disabled,
    questionKey,
    formMethods,
  }

  switch (question?.kind) {
    case 'SHORT_TEXT':
      return <CustomFormTextQuestion {...viewerQuestionProps} />
    case 'LONG_TEXT':
      return <CustomFormLongTextQuestion {...viewerQuestionProps} />
    case 'INTEGER':
    case 'DECIMAL':
      return <CustomFormNumberQuestion {...viewerQuestionProps} />
    case 'SINGLE_SELECTION_BOX':
      return <CustomFormSingleSelectionBoxQuestion {...viewerQuestionProps} />
    case 'MULTIPLE_SELECTION_BOX':
      return <CustomFormMultipleSelectionBoxQuestion {...viewerQuestionProps} />
    case 'SINGLE_SELECTION_LIST':
      return <CustomFormSingleSelectionListQuestion {...viewerQuestionProps} />
    case 'EMAIL':
      return <CustomFormMailQuestion {...viewerQuestionProps} />
    case 'DATE':
      return <CustomFormDateQuestion {...viewerQuestionProps} />
    case 'TIME':
      return <CustomFormHourQuestion {...viewerQuestionProps} />
    case 'PHONE':
      return <CustomFormPhoneQuestion {...viewerQuestionProps} />
    case 'CEP':
      return <CustomFormCEP {...viewerQuestionProps} />
    case 'SINGLE_FILE_UPLOAD':
      return <CustomFormSingleUpload {...viewerQuestionProps} />
    case 'MULTIPLE_FILE_UPLOAD':
      return <CustomFormMultipleUpload {...viewerQuestionProps} />
    case 'ENTITY':
      return <CustomFormEntity {...viewerQuestionProps} />
    case 'DOCUMENT':
      return <CustomFormDocuments {...viewerQuestionProps} />
    case 'NPS':
      return <CustomFormNPS {...viewerQuestionProps} />
    default:
      return null
  }
}
